var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSelectedStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1332_3217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0405 0H8.25745V4.74292H10.0405V0Z",
    fill: "#D1EF70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0405 11.2551H8.25745V15.998H10.0405V11.2551Z",
    fill: "#D1EF70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9175 7.10849H12.1746V8.8915H16.9175V7.10849Z",
    fill: "#D1EF70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.66238 7.10849H0.919464V8.8915H5.66238V7.10849Z",
    fill: "#D1EF70"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1332_3217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.919464)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSelectedStar);
export default __webpack_public_path__ + "static/media/icon-selected-star.b2154efeadd322adb3fd593315b570f6.svg";
export { ForwardRef as ReactComponent };